import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import i18n from "@/i18n";
import { buildHead } from "@/lib/seo";
import { DynamicLegalPage } from "@/components/pages/DynamicLegalPage";

export const Route = createFileRoute("/cgv")({
  head: () =>
    buildHead({
      lang: "fr",
      page: "home",
      title: "Conditions générales de vente · 2AM Hospitality",
      description:
        "Conditions générales de vente applicables aux prestations de 2AM Hospitality (BCE BE 0786 281 406).",
    }),
  component: () => {
    useEffect(() => {
      if (i18n.language !== "fr") i18n.changeLanguage("fr");
    }, []);
    if (i18n.language !== "fr") i18n.changeLanguage("fr");
    return <DynamicLegalPage slug="cgv" />;
  },
});
